import { Tabs, Typography } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Profile from './Profile';
import Documents from './Documents';
import { useState } from 'react';

const { Title } = Typography;

const Account = () => {
  const [activeKey, setActiveKey] = useState('1');
  
  return (
    <Content className='bg-[#F9F5F0] rounded-lg p-4 m-2 h-[98%] overflow-auto'>
      <Title level={5} className='ml-4'>My Account</Title>
      <Tabs type='card' className='mt-4 bg-white' onChange={setActiveKey} items={[
        { 
          label: `Profile Info`,
          key: '1',
          children: <Profile tabIndex={activeKey}/>
        },
        { 
          label: `Documents`,
          key: '2',
          children: <Documents />
        },
      ]}>
      </Tabs>
    </Content>
  );
};

export default Account;
